import React, {useState} from "react";
import LanguageService from "../../../services/Language.service";
import {KEYWORD_SEARCH_PLACEHOLDER} from "../../../constants/EventPage.constants";

export default function SearchBar({onSearch}) {
  const [query, setQuery] = useState("");
  const handleSearch = () => {
    onSearch && onSearch(query);
  };
  return (
    <div className="sn-offerings-search-simple search-bar">
      <input
        className="form-control"
        placeholder={LanguageService.translate(KEYWORD_SEARCH_PLACEHOLDER)}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        data-testid="searchBar"
      />
      <div
        data-testid="searchBtn"
        className="sn-offerings-simple-search-btn"
        onClick={handleSearch}
      >
        <span className="td-icon td-icon-search"></span>
      </div>
    </div>
  );
}
